<div class="loading-ios">
    <div class="loading-wrapper">
        <div class="loading-spinner">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</div>
